import axios from 'axios';

const api_url = process.env.REACT_APP_API_URL;

// Types for aggregated dashboard API
export interface AggregatedSecurityContext {
    atsFilter: string;
    dashboardType: string;
    userId: number;
    isAggregatedAdmin: boolean;
}

export interface AggregatedSecurityContextResponse {
    security_context: AggregatedSecurityContext;
    available_ats: string[];
    message: string;
}

export interface RemoteOrganizationSummary {
    ats_id: string;
    organization_id: string;
    company_name: string;
    ats_partner: string;
}

export interface AvailableOrganizationsResponse {
    organizations: RemoteOrganizationSummary[];
    count: number;
}

export interface UserAtsTypeResponse {
    ats_type: string;
    user_id: number;
    available_ats_types: string[];
    message: string;
}

// Get the ATS type assigned to the current user
export const getUserAtsType = async () => {
    return await axios.get<UserAtsTypeResponse>(
        `${api_url}dashboards/aggregated/user-ats-type/`
    );
};

// Get security context for aggregated dashboard
export const getAggregatedSecurityContext = async (atsFilter?: string) => {
    const params = atsFilter ? { ats_filter: atsFilter } : {};
    return await axios.get<AggregatedSecurityContextResponse>(
        `${api_url}dashboards/aggregated/security-context/`,
        { params }
    );
};

// Get list of available organizations for aggregated view
export const getAvailableOrganizations = async (atsFilter?: string) => {
    const params = atsFilter ? { ats_filter: atsFilter } : {};
    return await axios.get<AvailableOrganizationsResponse>(
        `${api_url}dashboards/aggregated/available-organizations/`,
        { params }
    );
};

// Check if current user has aggregated dashboard access
export const checkAggregatedDashboardAccess = async () => {
    try {
        await getAggregatedSecurityContext();
        return true;
    } catch (error: any) {
        if (error.response?.status === 403) {
            return false;
        }
        throw error;
    }
}; 